import React from "react";
import { Field, reduxForm } from "redux-form";
import history from "../../history";
import * as util from "../../shared/utility";

class OfferForm extends React.Component {
  onSubmit = (formValues) => {
    this.props.onSubmit(formValues);
  };

  handleCancelClick = () => {
    history.goBack();
  };

  render() {
    return (
      <form
        onSubmit={this.props.handleSubmit(this.onSubmit)}
        className="ui form error"
      >
        <Field name="name" component={util.RenderInput} label="Name:" />
        <Field
          name="bodyText"
          component={util.RenderInputMultilineHtml}
          label="Body:"
          height={1000}
        />
        <Field
          name="remarks"
          component={util.RenderInputMultiline}
          label="Remarks:"
        />
        <button className="ui button primary" disabled={this.props.submitting}>
          Save
        </button>
        <button
          type="button"
          className="ui button"
          onClick={this.handleCancelClick}
        >
          Back
        </button>
      </form>
    );
  }
}

const validate = (formValues) => {
  const errors = {};

  if (!formValues.name) {
    errors.name = "You must enter a name for the offer.";
  }

  if (!formValues.body) {
    errors.body = "You must enter a body for the offer.";
  }

  if (formValues.name && formValues.name.length > 200) {
    errors.name = "The name cannot exceed 200 characters.";
  }

  if (formValues.remarks && formValues.remarks.length > 500) {
    errors.remarks = "The remarks cannot exceed 500 characters.";
  }

  return errors;
};

export default reduxForm({
  form: "offerForm",
  validate,
})(OfferForm);
